import { useContext } from "react";
import { AlertContext } from "../context/AlertContext";

const Alert = () => {
  const context = useContext(AlertContext);

  if (!context) return null; // provider no está

  const { alert } = context;

  if (!alert) return null;

  return (
    <div className={`global-alert ${alert.type}`}>
      {alert.message}
    </div>
  );
};

export default Alert;
